export default __webpack_public_path__ + "static/media/container.757164ff.png";